module.exports = __webpack_public_path__ + "img/NameTheBand.fe2901d5.jpg";